import { useMutation } from '@tanstack/react-query'
import { getPreviousBooking } from 'repositories/BerthApi/getPreviousBooking'
import type { PreviousBookingOverrideParams } from 'repositories/BerthApi/getPreviousBooking/type'

type CheckPreviousBookingParams = {
  bookingId: string
} & PreviousBookingOverrideParams

export function useCheckPreviousBooking() {
  return useMutation({
    mutationFn: ({ bookingId, ...overrideParams }: CheckPreviousBookingParams) =>
      getPreviousBooking(bookingId, overrideParams),
  })
}
